<template lang="pug">
a.decor-button(@click="downloadGame")
  slot
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DownloadButton",

  computed: {
    ...mapGetters("global", ["isUserInProject", "isUserNotAuthed", "isUserAuthedNotRegistered"]),
  },

  methods: {
    downloadGame() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      } else if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      } else {
        this.$authService.downloadGameCenter();
      }
    },
  },
};
</script>
